import classNames from "classnames";
import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import { LeaveSpaceConfirmationModal } from "@circle-react/components/Spaces/LeaveSpaceConfirmationModal";
import { Button } from "@circle-react-uikit/Button";

export interface SpaceCardButtonsCurrentUserProps {
  isSpaceMember: boolean;
  spaceAccessViaPaywall: boolean;
  shouldShowDeletePopup: boolean;
  toggleDeletePopup: () => void;
  space: any;
  joinSpace: () => void;
  isViewOnlyMasquerading: boolean;
  isPrivate: boolean;
  isAdmin: boolean;
}

export const SpaceCardButtonsCurrentUser = ({
  isSpaceMember,
  spaceAccessViaPaywall,
  shouldShowDeletePopup,
  toggleDeletePopup,
  space,
  joinSpace,
  isViewOnlyMasquerading,
  isPrivate,
  isAdmin,
}: SpaceCardButtonsCurrentUserProps) => {
  const shouldShowLeaveButton = isSpaceMember && !spaceAccessViaPaywall;
  const shouldShowJoinButton =
    (!spaceAccessViaPaywall && !isPrivate) || isAdmin;

  if (shouldShowLeaveButton) {
    return (
      <div className="space-card__actions">
        <LeaveSpaceConfirmationModal
          show={shouldShowDeletePopup}
          onClose={toggleDeletePopup}
          space={space}
        />
        <Button
          type="button"
          variant="secondary"
          onClick={isViewOnlyMasquerading ? noop : toggleDeletePopup}
        >
          {t("leave_this_space")}
        </Button>
      </div>
    );
  }

  if (shouldShowJoinButton) {
    return (
      <div className="space-card__actions">
        <Button
          variant="primary"
          onClick={isViewOnlyMasquerading ? noop : joinSpace}
          className={classNames({
            "cursor-not-allowed": isViewOnlyMasquerading,
          })}
        >
          {t("join_space")}
        </Button>
      </div>
    );
  }

  return null;
};
